import { useState } from "react";
import type { CalcResult } from "@h2lca/core";
import { ApiError } from "@/lib/api";
import { resultSummary, useWorkshop } from "@/store/workshop";

/** 서버 보관함 저장 , 성공,실패 메시지까지. 산정 화면 머리와 시나리오 화면이 같은 것을 쓴다 */
export function useSave(result: CalcResult | null) {
  const saving = useWorkshop((s) => s.saving);
  const saveToServer = useWorkshop((s) => s.saveToServer);
  const [error, setError] = useState<string | null>(null);
  const save = async () => {
    setError(null);
    try {
      await saveToServer(result ? resultSummary(result) : undefined);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : e instanceof Error ? e.message : "저장에 실패했습니다");
    }
  };
  return { save, saving, error, clearError: () => setError(null) };
}
